<template>
    <div class="columns">
      	<div class="column is-two-thirds">
          	<div class="row" v-for="blog in blogs" :key="blog._id">
              	<BlogRow :blog="blog" />
          	</div>
      	</div>
      	<mq-layout mq="md+">
	      	<div class="column">
	      	    <h4 class="title">Blogs list</h4>
			  	<div v-for="blog in blogslist" :key="blog._id">
					<router-link tag="a" :to="{name: 'blog', params: {slug: blog.slug}}">
						{{ blog.title }}
					</router-link>
	          	</div>
	      	</div>
      	</mq-layout>
    </div>
</template>

<script>
import BlogRow from './BlogRow';

export default {
    props: ['blogs', 'blogslist'],
    components: {
        BlogRow
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/BlogRows.vue